import type { Actions } from '@atlaskit/onboarding/types';

type Action = Actions[number] & { ctaType?: 'primary' | 'secondary' };
type CTAs = { primary?: Action; secondary?: Action };

export const actions = (value?: Action[]): CTAs => {
	if (!value || value.length === 0) {
		return {};
	}

	if (value.length === 1) {
		const [primary] = value;
		return {
			primary,
		};
	}

	const primary = value.find((action) => action.ctaType === 'primary');
	const secondary = value.find((action) => action.ctaType === 'secondary');

	if (primary && secondary) {
		return {
			primary,
			secondary,
		};
	}

	if (primary) {
		// Only primary found, assign the other as secondary
		const other = value.find((action) => action !== primary);
		return { primary, secondary: other };
	}

	if (secondary) {
		// Only secondary found, assign the other as primary
		const other = value.find((action) => action !== secondary);
		return { primary: other, secondary };
	}

	// Neither ctaType is set, assume second is primary, first is secondary
	const [secondaryFallback, primaryFallback] = value;
	return { primary: primaryFallback, secondary: secondaryFallback };
};
